import { useLang } from "../context/LangContext";
import { Seo } from "../components/Seo";
import { Reveal, Hairline } from "../components/motion";

export default function Privacidade() {
  const { t } = useLang();
  const p = t.privacy;
  return (
    <>
      <Seo title={p.metaTitle} description={p.metaDesc} pageKey="privacidade" />
      <section className="pt-28 pb-16 md:pt-40 md:pb-24 bg-ink min-h-screen">
        <div className="container-lux max-w-3xl">
          <Reveal><div className="overline mb-6">{p.overline}</div></Reveal>
          <Reveal delay={0.1}><h1 className="font-serif text-5xl md:text-6xl font-light text-cream">{p.h1}</h1></Reveal>
          <Hairline className="my-12 max-w-xs" delay={0.2} />
          <div className="space-y-12">
            {p.sections.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.05}>
                <h2 className="font-serif text-2xl text-gold mb-4">{s.title}</h2>
                <p className="text-sand text-lg leading-relaxed font-light">{s.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
